/** 운영 프로모션별 카카오/URL 공유 이미지 오버라이드 */
export const PROMOTION_SHARE_IMAGE_OVERRIDES: Record<number, string> = {
  53: 'https://wimage.wconcept.co.kr/msa-event/event/default/20260604172755595_7603.png',
};

export function getPromotionShareImageUrl(
  promotionId?: number
): string | undefined {
  if (promotionId === undefined) {
    return undefined;
  }

  return PROMOTION_SHARE_IMAGE_OVERRIDES[promotionId];
}
